import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TemplateService } from 'src/app/services/template.service';
@Component({
  selector: 'app-add-template',
  templateUrl: './add-template.component.html',
  styleUrls: ['./add-template.component.scss']
})
export class AddTemplateComponent implements OnInit {
  form: FormGroup;
  language = 'fr';
  constructor(public fb: FormBuilder, public tempService: TemplateService, public dialogRef: MatDialogRef<AddTemplateComponent>) {
    this.form = this.fb.group({
      name: [''],
      description: [null],
      fileTemplate: [null],
      language: [null],
      templateGroupId: [null]
    });
  }

  ngOnInit(): void {
  }

  uploadFile(event: any): void {
    const file = (event.target as HTMLInputElement).files;
    console.log(file?.item(0));
    this.form.patchValue({
      fileTemplate: file?.item(0)
    });
    this.form.get('fileTemplate')?.updateValueAndValidity();
  }

  addTemplate(): void {
    const formData = new FormData();
    formData.append('name', this.form.get('name')?.value);
    formData.append('description', this.form.get('description')?.value);
    formData.append('templateGroupId', '1');
    formData.append('language', this.form.get('language')?.value);
    formData.append('file', this.form.get('fileTemplate')?.value);
    console.log(this.form.get('language')?.value);
    this.tempService.addTemplate(formData);
    this.dialogRef.close();
  }

  closeTemplate(): void{
    this.dialogRef.close();
  }

}
